export default __webpack_public_path__ + "static/2138-75d327acd50863a866c683d01f984801.gif";